import React, {useEffect, useState,useRef} from "react";
import {Link} from "react-router-dom";
import {getAllRoom} from "../../utility/serverUtility";
import {isSuccess} from "../../utility/utility";
import Loader from "./Loader";
import PhotoGallerySearch from "./PhotoGallerySearch";
function SingleFeed(props) {
    const [rooms,setRooms] = useState([])
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        async function fetchData() {
            const response = await getAllRoom(null,null)
            if (isSuccess(response)) {
                if(props.keyword!=null){
                    setItems(response.data.risultato.rooms.filter(room => verifyName(room.nome,props.keyword)))
                    setRooms(response.data.risultato.rooms)
                }
                else{
                    setItems(response.data.risultato.rooms)
                    setRooms(response.data.risultato.rooms)

                }
                setLoading(false)
            }
        }
        fetchData();
    }, []);

    useEffect(() => {
        if(props.keyword!=null) {
            setItems(rooms.filter(room => verifyName(room.nome,props.keyword)))
        }
    },[props.keyword]);

    const verifyName= (name,keyword)=>{
        return name.toLowerCase().includes(keyword.toLowerCase())
    }
    const handleClick = () => {
        // Force a reload by calling forceUpdate on the Link component

        window.location.reload();

    }

    const renderitems = items.map((item, i) => {
        return <div key={i} className="single-popular-feed">
            <div className="feed-img">
                {/*<img src={item.foto.length!=0?item.foto[0]:(process.env.PUBLIC_URL + "/assets/img/image-utility/search-empty-image.jpg")}/>*/}
                <PhotoGallerySearch foto={item.foto.length!=0?item.foto[0]:(process.env.PUBLIC_URL + "/assets/img/image-utility/search-empty-image.jpg")}/>
            </div>
            <div className="feed-desc">
                <h6><div onClick={handleClick}><Link  to={"/room/details/" + item.id}>{item.nome}</Link></div></h6>
            </div>
        </div>
    });
    return (
        <div className="sidebar-search">
            <div className="widget popular-feeds mb-40">
                <div className="popular-feed-loop">
                    {loading === false ? renderitems : <Loader />}
                </div>
            </div>
        </div>
    );
}

export default SingleFeed;